"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.YoutubeVideosService = void 0;
var tslib_1 = require("tslib");
var url_types_1 = require("@wix/wix-vod-constants/dist/common/url-types");
var internal_error_1 = require("@wix/wix-vod-constants/dist/api-types/internal-error");
var to_error_1 = require("../../parsers/to-error");
var video_1 = require("./parsers/video");
var video_item_1 = require("../../parsers/video-item");
var youtube_channels_service_1 = require("./youtube-channels-service");
var enums_1 = require("@wix/wix-vod-constants/dist/api-types/enums");
var youtube_1 = require("@wix/wix-vod-api-site-based/dist/src/public/services/youtube/youtube");
var YoutubeVideosService = /** @class */ (function () {
    function YoutubeVideosService(httpClient) {
        this.httpClient = httpClient;
        this.youtubeService = new youtube_1.YoutubeService(httpClient);
        this.youtubeChannelsService = new youtube_channels_service_1.YoutubeChannelsService(httpClient);
    }
    YoutubeVideosService.prototype.mapParams = function (channel, options) {
        var externalId = channel.externalId, urlType = channel.urlType;
        var item = {
            externalId: externalId,
            urlType: urlType,
            pageToken: options.paging.cursor,
            itemsCount: options.paging.size,
        };
        return item;
    };
    YoutubeVideosService.prototype.getCategoryIdToTitleMapping = function (categoryItems) {
        return _.reduce(categoryItems, function (categoriesByIds, category) {
            var _a;
            return (_a = {},
                _a[category.id] = category.snippet.title,
                _a);
        }, {});
    };
    YoutubeVideosService.prototype.addCategory = function (categoriesByIds, item) {
        var categoryId = _.get(item, 'snippet.categoryId');
        var category = categoriesByIds[categoryId];
        if (category) {
            _.set(item, 'snippet.category', category);
        }
        return item;
    };
    YoutubeVideosService.prototype.mapToVodPaginatedResponse = function (response, options) {
        var _this = this;
        var _a = response.data, nextPageToken = _a.nextPageToken, playlistItems = _a.playlistItems, videoItems = _a.videoItems, categoryItems = _a.categoryItems, channelItems = _a.channelItems;
        var categoriesByIds = this.getCategoryIdToTitleMapping(categoryItems);
        var channelsData = _.keyBy(channelItems, 'id');
        var addCategoryToVideo = function (item) {
            return _this.addCategory(categoriesByIds, item);
        };
        var mergedItems = videoItems.map(function (videoItem, index) {
            return _.merge(videoItem, playlistItems[index]);
        });
        return {
            status: response.status,
            sort: options.sort,
            paging: tslib_1.__assign(tslib_1.__assign({}, options.paging), { cursor: nextPageToken }),
            data: _(mergedItems)
                .map(addCategoryToVideo)
                .map(function (item) {
                var _a, _b;
                return (tslib_1.__assign(tslib_1.__assign({}, (0, video_1.parseYoutubeVideo)(item)), { publisher: (_b = (_a = channelsData[item.snippet.channelId]) === null || _a === void 0 ? void 0 : _a.snippet) === null || _b === void 0 ? void 0 : _b.title }));
            })
                .value(),
        };
    };
    YoutubeVideosService.prototype.listYoutubeChannelVideosInternal = function (channel, options, hydratedChannelVideos) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var params, response, _a;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        params = this.mapParams(channel, options);
                        _a = hydratedChannelVideos;
                        if (_a) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.youtubeService.getChannelVideos(params)];
                    case 1:
                        _a = (_b.sent());
                        _b.label = 2;
                    case 2:
                        response = _a;
                        return [2 /*return*/, this.mapToVodPaginatedResponse(response, options)];
                }
            });
        });
    };
    YoutubeVideosService.prototype.getVideosByChannelId = function (channelId, options) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                return [2 /*return*/, this.listYoutubeChannelVideosInternal({ externalId: channelId, urlType: url_types_1.URL_TYPES.CHANNEL }, options).catch(to_error_1.toError)];
            });
        });
    };
    YoutubeVideosService.prototype.getVideosByPlaylistId = function (playlistId, options) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                return [2 /*return*/, this.listYoutubeChannelVideosInternal({ externalId: playlistId, urlType: url_types_1.URL_TYPES.PLAYLIST }, options).catch(to_error_1.toError)];
            });
        });
    };
    YoutubeVideosService.prototype.getVideosByUserName = function (userName, options) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                return [2 /*return*/, this.youtubeService
                        .getChannelsByUsername(userName)
                        .then(function (response) { return response.data.items[0]; })
                        .then(function (channel) { return channel.id; })
                        .then(function (channelId) { return _this.getVideosByChannelId(channelId, options); })
                        .catch(to_error_1.toError)];
            });
        });
    };
    YoutubeVideosService.prototype.getYoutubeVideoByIdWithChannelData = function (videoId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var videoResponse, channel;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getYoutubeVideoById(videoId)];
                    case 1:
                        videoResponse = _a.sent();
                        return [4 /*yield*/, this.youtubeChannelsService
                                .getChannelsByIds([videoResponse.data.channelId])
                                .then(function (response) { return response.data[0]; })];
                    case 2:
                        channel = _a.sent();
                        return [2 /*return*/, tslib_1.__assign(tslib_1.__assign({}, videoResponse), { data: tslib_1.__assign(tslib_1.__assign({}, videoResponse.data), { publisher: channel ? channel.title : null }) })];
                }
            });
        });
    };
    YoutubeVideosService.prototype.getVideosByUrl = function (url, skipVideos) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var type, id, result, options, _a, response, error_1;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        try {
                            result = skipVideos
                                ? this.youtubeService.parseChannelUrl(url)
                                : this.youtubeService.parseVideoUrl(url);
                            type = result.type;
                            id = result.id;
                        }
                        catch (e) {
                            return [2 /*return*/, Promise.reject(new internal_error_1.InternalError(0, 'wpm_error.malformed_external_link'))];
                        }
                        options = {
                            paging: {
                                cursor: null,
                                size: 50,
                            },
                            sort: {
                                order: enums_1.SortOrders.Relevance,
                            },
                        };
                        _a = type;
                        switch (_a) {
                            case url_types_1.URL_TYPES.CHANNEL: return [3 /*break*/, 1];
                            case url_types_1.URL_TYPES.PLAYLIST: return [3 /*break*/, 2];
                            case url_types_1.URL_TYPES.USER_NAME: return [3 /*break*/, 3];
                        }
                        return [3 /*break*/, 4];
                    case 1: return [2 /*return*/, this.getVideosByChannelId(id, options)];
                    case 2: return [2 /*return*/, this.getVideosByPlaylistId(id, options)];
                    case 3: return [2 /*return*/, this.getVideosByUserName(id, options)];
                    case 4:
                        _b.trys.push([4, 6, , 7]);
                        return [4 /*yield*/, this.getYoutubeVideoByIdWithChannelData(id)];
                    case 5:
                        response = _b.sent();
                        return [2 /*return*/, tslib_1.__assign(tslib_1.__assign({}, response), { data: [response.data] })];
                    case 6:
                        error_1 = _b.sent();
                        return [2 /*return*/, (0, to_error_1.toError)(error_1)];
                    case 7: return [2 /*return*/];
                }
            });
        });
    };
    YoutubeVideosService.prototype.getYoutubeVideoById = function (videoId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var response, _a, items, categoryItems, categoriesByIds, item, parsedItem;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, this.youtubeService.getVideoById(videoId)];
                    case 1:
                        response = _b.sent();
                        _a = response.data, items = _a.items, categoryItems = _a.categoryItems;
                        categoriesByIds = this.getCategoryIdToTitleMapping(categoryItems);
                        item = this.addCategory(categoriesByIds, items[0]);
                        parsedItem = (0, video_1.parseYoutubeVideo)(item);
                        return [2 /*return*/, tslib_1.__assign(tslib_1.__assign({}, response), { data: tslib_1.__assign(tslib_1.__assign({}, parsedItem), { id: parsedItem.externalId }) })];
                }
            });
        });
    };
    YoutubeVideosService.prototype.listYoutubeChannelVideos = function (channel, options, hydratedChannelVideos) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var response;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.listYoutubeChannelVideosInternal(channel, options, hydratedChannelVideos)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, tslib_1.__assign(tslib_1.__assign({}, response), { data: response.data.map(video_item_1.parseVideoItem) })];
                }
            });
        });
    };
    return YoutubeVideosService;
}());
exports.YoutubeVideosService = YoutubeVideosService;
//# sourceMappingURL=youtube-videos-service.js.map